import { required, optional, array, obj } from 'AppReact/schema';

const address = {
  address: required('string'),
  city: required('string'),
  state: required('string'),
  zip: required('string'),
}

export const client_module = obj({
  client: optional("string"),
  client_id: required('integer'),
  enabled: required('boolean'),
  id: required('integer'),
  module: optional("string"),
  module_id: required('integer')
})

export const client_modules =  array(client_module)
export const client = {
  client_modules,
  id: required('integer'),
  name: required('string'),
  pms_url: optional('string'),
  twilio_number: optional('string'),
  unit_cost: optional('number'),
  has_properties_missing_billing_info: optional('boolean'),
  billing_email: optional('string'),
  billing_name: optional('string'),
  billing_phone: optional('string'),
  billing_address: obj(address),
  status: required('string'),
  client_schema: required('string'),
  active_properties: required('integer'),
  active_units: required('integer'),
  avg_callback: required('number'),
  avg_saturation: required('number'),
  external_id: optional("string"),
  inserted_at: required("string"),
  updated_at: required("string"),
  users: array("string"),
  user: obj({
    client: optional("string"),
    client_id: required("integer"),
    email: optional("string"),
    encrypted_password: optional("string"),
    id: required("integer"),
    inserted_at: required("string"),
    updated_at: required("string"),
    name: optional('string'),
    password: optional('string'),
    password_hash: required('string'),
    phone_number: optional('string'),
    roles: optional('string'),
    schema_id: required("integer"),
    type: required('string'),
    username: required('string'),
  }),
}